import { PointsToCashForMortgageGqlMutations } from './mutations'
import { PointsToCashForMortgageGqlQueries } from './queries'
export const PointsToCashForMortgageGql = {
  Mutations: PointsToCashForMortgageGqlMutations,
  Queries: PointsToCashForMortgageGqlQueries,
}
